/**
 * Shared resource identifier keys used by plugins to declare their
 * child resources via `getExtraChildResources()` so the detailed-show
 * resolver can hydrate IDs into human-readable names.
 */

/**
 * Resource key for clinics identified by their opaque `clinicSn`; resolved to
 * clinic names via the SN-native `/clinics/by-condition` batch lookup.
 *
 * Superseded the `clinic-identifier` key, which was built from
 * `AysClinicIdentifier#toString()` and therefore could not be built at all for a
 * clinicSn-only identity (no `ik` → `toString()` is null). Removed in BDA-5855
 * once the geo-parts plugins — its last emitters — moved over.
 */
export const FILTER_RESOURCE_CLINIC_SN = 'clinic-sn';

/**
 * Resource key for the CLINIC operating numbers of the blueprint-driven
 * `operatingNumber` (Kennzahl) condition; resolved via
 * `GET /clinics/available-operating-numbers`.
 *
 * Deliberately NOT the same key as the case-grain `operating-number` of the
 * virtual-clinic Kennzahl-Filter — that one resolves against a different
 * catalog (`available-fully-inpatient-case-operating-numbers`), where a clinic
 * id such as `anzahlApotheker` does not exist.
 */
export const FILTER_RESOURCE_CLINIC_OPERATING_NUMBER =
  'clinic-operating-number';
